import React, { useMemo } from 'react'
import { string, shape, object, bool } from 'prop-types'

import Card from '@/components/ProductList/Card'
import { isTutorialApp } from '@/utils/products'
import Subtitle from './Subtitle'

const ProductCard = ({ app, isFeatured }) => {
  const {
    id,
    logo,
    icons,
    slug,
    name,
    isPrivateApp,
    shortDescription,
    payment,
    product: designation,
    customProps,
    rating,
  } = app

  const isService = customProps?.isService === 'true'
  const isAiApplication = customProps?.isAiPowered === 'true'
  const isTutorial = isTutorialApp(app)

  const linkToApp = useMemo(() => {
    if (isPrivateApp) {
      return `/private-apps/${id}/`
    }

    if (isService) {
      return `/services/${slug}/`
    }

    return `/apps/${slug}/`
  }, [slug, id, isPrivateApp, isService])

  return (
    <Card
      link={linkToApp}
      isFeatured={isFeatured}
      icons={icons}
      logo={logo}
      title={name}
      subtitle={
        <Subtitle
          id={id}
          payment={payment}
          rating={rating}
          designation={designation}
          isTutorialApp={isTutorial}
          isAiApplication={isAiApplication}
        />
      }
      description={shortDescription}
    />
  )
}

ProductCard.propTypes = {
  app: shape({
    slug: string,
    id: string,
    icons: object,
    name: string,
    payment: object,
    shortDescription: string,
    isInstalled: bool,
    useLegacyButtons: bool,
    isPrivateApp: bool,
  }),
  isFeatured: bool,
  isLoadingRating: bool,
  rating: object,
  areServices: bool,
}

export default ProductCard
